import { useState } from 'react';
import GoldSubscriptionModal from '../GoldSubscriptionModal/GoldSubscriptionModal';
import garcom_personagem from '../../assets/garcom-novo.png';
import './GoldWidget.scss';

const IconBell = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#A86C00"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
);

export default function GoldWidget() {
    const [showBubble, setShowBubble] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleToggleBubble = () => {
        setShowBubble((prev) => !prev);
    };

    const handleOpenModal = () => {
        setShowBubble(false);
        setShowModal(true);
    };

    return (
        <>
            <div className="gold-widget">
                {showBubble && (
                    <div className="gold-widget__bubble">
                        <button
                            className="gold-widget__bubble-close"
                            onClick={() => setShowBubble(false)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        <div className="gold-widget__bubble-content">
                            <div className="gold-widget__speech">
                                Olá, eu me chamo Duke, como posso ajudar? Clique em mim para ser Gold!
                            </div>

                            <div className="gold-widget__character" onClick={handleOpenModal}>
                                <img src={garcom_personagem} alt="Duke, o garçom" />
                            </div>
                        </div>

                        <button className="gold-widget__cta" onClick={handleOpenModal}>
                            SEJA GOLD <span className="gold-widget__cta-arrow">›</span>
                        </button>
                    </div>
                )}

                <button
                    className="gold-widget__trigger"
                    onClick={handleToggleBubble}
                    aria-label="Assinatura Gold"
                >
                    <IconBell />
                </button>
            </div>

            {showModal && (
                <GoldSubscriptionModal onClose={() => setShowModal(false)} />
            )}
        </>
    );
}